module.exports = __webpack_public_path__ + "img/1726043492608-screenshot-1726039223207.png.24a99409.webp";